import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body"]

  static values = {
    locale: String
  }

  connect() {}

  updateModal(e) {
    const url = `/client/proposals/${e.currentTarget.dataset.proposalId}?locale=${this.localeValue}`
    fetch(url, {headers: {"Accept": "text/plain"}})
      .then(response => response.text())
      .then((data) => {
        this.bodyTarget.innerHTML = data
      })
  }
}
